import ObjectListWidget from '@plone/volto/components/manage/Widgets/ObjectListWidget';

const itemSchema = {
  title: '',
  properties: {
    textline: {
      title: 'Text',
      wrapped: false,
    },
  },
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['textline'],
    },
  ],
  required: [],
};

interface TextlinesWidgetItem {
  '@id': string;
  textline?: string;
}

export interface TextlinesWidgetProps {
  value?: Array<TextlinesWidgetItem>;
  default?: Array<TextlinesWidgetItem>;
  onChange: (id: string, value: Array<TextlinesWidgetItem>) => void;
}

const TextlinesWidget: React.FC<TextlinesWidgetProps> = (props) => {
  const { value, default: defaultValue, onChange, ...rest } = props;

  return (
    <div className="textlines-widget">
      <ObjectListWidget
        schema={itemSchema}
        {...rest}
        value={value || defaultValue || []}
        onChange={(id: string, value: Array<TextlinesWidgetItem>) =>
          onChange(id, value)
        }
      />
    </div>
  );
};

export default TextlinesWidget;
